var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.component,{tag:"component",on:{"ok":function($event){return _vm.$emit('ok')}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }